import {
  FETCH_TOTAL_ACCURACY_REQUEST,
  FETCH_TOTAL_ACCURACY_SUCCESS,
  FETCH_TOTAL_ACCURACY_ERROR,
  CLEAR_TOTAL_ACCURACY,
  CANCEL_TOTAL_ACCURACY,
} from 'actionTypes'

const DEFAULT_STATE = {
  record: {
    listPresenter: [],
  },
  error: null,
  canceled: null,
  isFetching: false,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_TOTAL_ACCURACY_REQUEST:
      return {
        ...state,
        canceled: false,
        isFetching: true,
      }

    case FETCH_TOTAL_ACCURACY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        canceled: false,
        record: action.payload,
      }

    case FETCH_TOTAL_ACCURACY_ERROR:
      return {
        ...state,
        isFetching: false,
        canceled: false,
        record: {
          listPresenter: [],
        },
        error: action.payload,
      }

    case CLEAR_TOTAL_ACCURACY:
      return {
        ...state,
        isFetching: false,
        error: null,
        canceled: false,
        record: {
          listPresenter: [],
        },
      }

      case CANCEL_TOTAL_ACCURACY:
      return {
        ...state,
        isFetching: false,
        error: null,
        canceled: true
      }
    default:
      return state
  }
}

export default record
